export default __webpack_public_path__ + "static/media/onboarding4.1f03ae4e.svg";